import { PlayerLocationData } from 'common/features/player/components/PlayerContainer';

import { AnnotationCountState } from './reducer';
import { PlayerFeatureOptions } from './types';

export enum TypeKeys {
    OPEN_WINDOW = 'player/OPEN_WINDOW',
    RESET = 'player/RESET',
    ERROR_RECEIVED = 'player/ERROR_RECEIVED',
    DISMISS_ERROR = 'player/DISMISS_ERROR',
    DISABLE_ANNOTATIONS = 'player/DISABLE_ANNOTATIONS',
    ENABLE_ANNOTATIONS = 'player/ENABLE_ANNOTATIONS',
    SET_ANNOTATION_COUNT = 'player/SET_ANNOTATION_COUNT',
    LANGUAGE_CHANGE = 'player/LANGUAGE_CHANGE',
    SET_ANNOTATION_SIDEBAR_STATUS = 'submission/SET_ANNOTATION_SIDEBAR_STATUS',
    NAVIGATION_REPORTED = 'player/NAVIGATION_REPORTED',
}

export interface SetAnnotationSidebarStatusAction {
    type: TypeKeys.SET_ANNOTATION_SIDEBAR_STATUS;
    featureId: string;
    options: PlayerFeatureOptions;
}

export interface SetAnnotationCountAction {
    type: TypeKeys.SET_ANNOTATION_COUNT;
    featureId: string;
    annotationCount: AnnotationCountState;
}

export interface DisableAnnotationsAction {
    type: TypeKeys.DISABLE_ANNOTATIONS;
    featureId: string;
}

export interface EnableAnnotationsAction {
    type: TypeKeys.ENABLE_ANNOTATIONS;
    featureId: string;
}

export interface LanguageChangeAction {
    type: TypeKeys.LANGUAGE_CHANGE;
    featureId: string;
}

export interface OpenWindowAction {
    type: TypeKeys.OPEN_WINDOW;
    featureId: string;
}

export interface ResetActions {
    type: TypeKeys.RESET;
    featureId: string;
}

export interface ErrorReceivedAction {
    type: TypeKeys.ERROR_RECEIVED;
    featureId: string;
    errorMessage: string;
}

export interface DismissErrorAction {
    type: TypeKeys.DISMISS_ERROR;
    featureId: string;
}

export interface NavigationReportedFromPlayerAction {
    type: TypeKeys.NAVIGATION_REPORTED;
    playerLocationData: PlayerLocationData;
    featureId: string;
}

export type ActionTypes = | OpenWindowAction | ResetActions |
    ErrorReceivedAction | DismissErrorAction | DisableAnnotationsAction
    | EnableAnnotationsAction | SetAnnotationCountAction | LanguageChangeAction
    | SetAnnotationSidebarStatusAction | NavigationReportedFromPlayerAction;

export const setAnnotationCountHeader = (featureId: string, annotationCount: AnnotationCountState):
    SetAnnotationCountAction => ({
    featureId,
    annotationCount,
    type: TypeKeys.SET_ANNOTATION_COUNT,
});

export const enableAnnotations = (featureId: string): EnableAnnotationsAction => ({
    featureId,
    type: TypeKeys.ENABLE_ANNOTATIONS,
});

export const disableAnnotations = (featureId: string): DisableAnnotationsAction => ({
    featureId,
    type: TypeKeys.DISABLE_ANNOTATIONS,
});

export const openWindow = (featureId: string): OpenWindowAction => ({
    featureId,
    type: TypeKeys.OPEN_WINDOW,
});

export const languageChange = (featureId: string): LanguageChangeAction => ({
    featureId,
    type: TypeKeys.LANGUAGE_CHANGE,
});

export const reset = (featureId: string): ResetActions => ({
    featureId,
    type: TypeKeys.RESET,
});

export const errorReceived = (featureId: string, errorMessage: string): ErrorReceivedAction => ({
    featureId,
    errorMessage,
    type: TypeKeys.ERROR_RECEIVED,
});

export const dismissError = (featureId: string): DismissErrorAction => ({
    featureId,
    type: TypeKeys.DISMISS_ERROR,
});

export const setAnnotationSidebarStatus = (featureId: string, options: PlayerFeatureOptions): SetAnnotationSidebarStatusAction => ({
    featureId,
    options,
    type: TypeKeys.SET_ANNOTATION_SIDEBAR_STATUS,
});

export const navigationReportedFromPlayer = (featureId: string, playerLocationData: PlayerLocationData): NavigationReportedFromPlayerAction => ({
    featureId,
    playerLocationData,
    type: TypeKeys.NAVIGATION_REPORTED,
});
